"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var CloseButton_1 = __importDefault(require("components/Buttons/CloseButton"));
var OptimiseButtons_1 = __importDefault(require("../OptimiseButtons"));
var PREFIX = 'NegotiateForHighExpenditure';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    descriptionHeadingContainer: "".concat(PREFIX, "-descriptionHeadingContainer"),
    descriptionHeading: "".concat(PREFIX, "-descriptionHeading"),
    topFeaturesContainer: "".concat(PREFIX, "-topFeaturesContainer"),
    serviceStatAttributeLabel: "".concat(PREFIX, "-serviceStatAttributeLabel"),
    serviceStatAttributeContainer: "".concat(PREFIX, "-serviceStatAttributeContainer"),
    rightAttributeContainer: "".concat(PREFIX, "-rightAttributeContainer"),
    isOpen: "".concat(PREFIX, "-isOpen"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.wrapper)] = {
            width: 'calc(100% - 28px)',
            marginLeft: 8,
        },
        _b[".".concat(classes.descriptionHeadingContainer)] = {
            color: 'hsl(0,0%,30%)',
            fontWeight: 500,
        },
        _b[".".concat(classes.descriptionHeading)] = {
            color: theme.palette.primary.main,
            fontSize: '1.25rem',
            fontWeight: 500,
        },
        _b[".".concat(classes.topFeaturesContainer)] = {
            marginLeft: '24px',
            height: '24px',
        },
        _b[".".concat(classes.serviceStatAttributeLabel)] = {
            width: '140px',
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.serviceStatAttributeContainer)] = {
            display: 'flex',
            fontSize: '1rem',
            color: theme.palette.primary.main,
            fontWeight: 500,
            marginTop: '8px',
            marginBottom: '8px',
        },
        _b[".".concat(classes.rightAttributeContainer)] = {
            marginLeft: 'auto',
            marginRight: '20px',
        },
        _b[".".concat(classes.isOpen)] = {
            width: 756,
            paddingTop: 32,
        },
        _b);
});
var NegotiateForHighExpenditure = function (_a) {
    var onClickClose = _a.onClickClose;
    return (((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "fs-md lh-3 d-flex color-primary justify-content-between" }, { children: [(0, jsx_runtime_1.jsx)("span", { children: "Negotiatate better pricing" }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { closeAction: onClickClose })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "my-6 ds-avatar__name fs-md" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.descriptionHeadingContainer }, { children: "Companies your size usually overpay for software licences. We negotiate directly with vendors to get you better prices for high expenditure software and help our clients pay the most competitive rates." })) })), (0, jsx_runtime_1.jsx)(OptimiseButtons_1.default, { activateText: "Yes, please", deferText: "Maybe later" })] })));
};
exports.default = NegotiateForHighExpenditure;
